/* tslint:disable */
/* eslint-disable */
/**
 * Modulos Platform API v1
 * API for the Modulos Platform.
 *
 * The version of the OpenAPI document: 2.5.7
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */




export const Status = {
    NotExecuted: 'not_executed',
    Executed: 'executed',
    InProgress: 'in_progress',
    InReview: 'in_review',
    Completed: 'completed',
    OutOfScope: 'out_of_scope',
    Archived: 'archived',
} as const;

export type Status = typeof Status[keyof typeof Status];



